<template>
  <v-row>
    <v-col cols="12">
      <v-card class="fill-height info_card" title="Official Entry Movie">
        <v-card-text>
          <AssetPreviewComponent
            :asset="movie"
            type="video"
            :isModal="false"
            :onUpload="handleFileUploadMovie"
            @assetSaved="handleAssetSaved"
            @snack="throwSnack" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" md="6">
      <v-card class="fill-height info_card" title="Team Video">
        <v-card-text>
          <AssetPreviewComponent
            :asset="teamVideo"
            type="video"
            :isModal="false"
            :onUpload="handleFileUploadTeamVideo"
            @assetSaved="handleAssetSaved"
            @snack="throwSnack" />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card class="fill-height info_card" title="Still Image">
        <v-card-text>
          <AssetPreviewComponent
            :asset="stillImage"
            type="image"
            :isModal="false"
            :onUpload="handleFileUploadStill"
            @assetSaved="handleAssetSaved"
            @snack="throwSnack" />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card class="fill-height info_card" title="Behind the Scenes Video">
        <v-card-text>
          <AssetPreviewComponent
            :asset="bts"
            type="video"
            :isModal="false"
            :onUpload="handleFileUploadBTS"
            @assetSaved="handleAssetSaved"
            @snack="throwSnack" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import AssetPreviewComponent from '@/components/ui/AssetPreviewComponent.vue';
import { uploadBTSVideo, uploadMovie, uploadScreenShot, uploadTeamVideo } from '@/controllers';
import { AssetDTO, IAssetDTO, ITeamDTO } from '@/dtos';
import { useSnack } from '@/helpers';
import { useAdminRegistrationStore } from '@/stores/modules/admin';

import { SNACKSTATUS } from '@/stores/util';
import { computed, ref } from 'vue';

const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
interface Props {
  teamId: string;
  yearId: string;
  team: ITeamDTO;
}
const props = defineProps<Props>();
const teamId = ref<string>(props.teamId);
const yearId = ref<string>(props.yearId);

const registrationStore = useAdminRegistrationStore();
const { data, isLoading } = registrationStore.getTeamRegistration(yearId, teamId);

const movie = computed(() => new AssetDTO(data.value?.movie));
const bts = computed(() => new AssetDTO(data.value?.bts));
const teamVideo = computed(() => new AssetDTO(data.value?.teamVideo));
const stillImage = computed(() => new AssetDTO(data.value?.screenshot));

const handleFileUploadMovie = async (
  file: File,
  updateProgress: (progress: number) => void,
): Promise<IAssetDTO> => {
  const response = await uploadMovie(
    teamId.value,
    yearId.value,
    data.value?.id || '',
    file,
    updateProgress,
  );
  return response;
};

const handleFileUploadTeamVideo = async (
  file: File,
  updateProgress: (progress: number) => void,
): Promise<IAssetDTO> => {
  const response = await uploadTeamVideo(
    teamId.value,
    yearId.value,
    data.value?.id || '',
    file,
    updateProgress,
  );
  return response;
};

const handleFileUploadBTS = async (
  file: File,
  updateProgress: (progress: number) => void,
): Promise<IAssetDTO> => {
  const response = await uploadBTSVideo(
    teamId.value,
    yearId.value,
    data.value?.id || '',
    file,
    updateProgress,
  );
  return response;
};

const handleFileUploadStill = async (
  file: File,
  updateProgress: (progress: number) => void,
): Promise<IAssetDTO> => {
  const response = await uploadScreenShot(
    teamId.value,
    yearId.value,
    data.value?.id || '',
    file,
    updateProgress,
  );
  return response;
};

const handleAssetSaved = async () => {
  await registrationStore.invalidate(yearId, teamId);
};
</script>
